import React from 'react';
import { type QueryDispatch, type SetStateAction } from 'react-router-use-location-state';

export type OrderProps = {
	orderBy?: string;
	orderOperator?: string;
	setOrderBy?:
		| ((newValue?: string) => void)
		| React.Dispatch<React.SetStateAction<string | undefined>>
		| QueryDispatch<SetStateAction<string>>;
	setOrderOperator?:
		| ((newValue?: string) => void)
		| React.Dispatch<React.SetStateAction<string | undefined>>
		| QueryDispatch<SetStateAction<string>>;
};

export interface OrderType {
	orderString?: string;
	orderBy?: string;
	orderOperator?: string;
	setOrderBy:
		| ((newValue?: string) => void)
		| React.Dispatch<React.SetStateAction<string | undefined>>
		| QueryDispatch<SetStateAction<string>>;
	setOrderOperator:
		| ((newValue?: string) => void)
		| React.Dispatch<React.SetStateAction<string | undefined>>
		| QueryDispatch<SetStateAction<string>>;
}

export default function useOrder(props: OrderProps) {
	const [orderBy, setOrderBy] = React.useState<string | undefined>();
	const [orderOperator, setOrderOperator] = React.useState<string | undefined>();

	return {
		orderString:
			props.orderBy && props.orderOperator
				? `${props.orderBy} ${props.orderOperator}`
				: orderBy && orderOperator
					? `${orderBy} ${orderOperator}`
					: undefined,
		orderBy: props.orderBy || orderBy,
		orderOperator: props.orderOperator || orderOperator,
		setOrderBy: props.setOrderBy || setOrderBy,
		setOrderOperator: props.setOrderOperator || setOrderOperator
	} as OrderType;
}
